import { createFileRoute } from '@tanstack/react-router'
import { AvailabilityPlanning } from 'pages/availabilityPlanning/AvailabilityPlanning'
import { availabilityPlanningSearchParams } from 'routes/availability-planning/-searchParams'

const RouteComponent = () => {
  const { siteId, shipId } = Route.useSearch()

  return <AvailabilityPlanning siteId={siteId} shipId={shipId} />
}

export const Route = createFileRoute('/availability-planning/')({
  component: RouteComponent,
  validateSearch: availabilityPlanningSearchParams,
  staticData: {
    layout: {
      enableScrolling: false,
    },
  },
})
